export const comparators = {
  EQU: {
    name: 'equals',
    label: '=',
    hasRight: true,
    template: function (l, r) {
      return `${l} ${this.label} ${r}`
    }
  },
  NEQ: {
    name: 'not equals',
    label: '!=',
    hasRight: true,
    template: function (l, r) {
      return `${l} ${this.label} ${r}`
    }
  },
  LES: {
    name: 'less than',
    label: '<',
    hasRight: true,
    template: function (l, r) {
      return `${l} ${this.label} ${r}`
    }
  },
  LEQ: {
    name: 'less than or equal to',
    label: '<=',
    hasRight: true,
    template: function (l, r) {
      return `${l} ${this.label} ${r}`
    }
  },
  GRT: {
    name: 'greater than',
    label: '>',
    hasRight: true,
    template: function (l, r) {
      return `${l} ${this.label} ${r}`
    }
  },
  GEQ: {
    name: 'greater than or equal to',
    label: '>=',
    hasRight: true,
    template: function (l, r) {
      return `${l} ${this.label} ${r}`
    }
  },
  EXT: {
    name: 'exists',
    label: 'Exists',
    hasRight: false,
    template: function (l) {
      return `${l} ${this.label}`
    }
  },
  NEX: {
    name: 'not exists',
    label: 'Does Not Exist',
    hasRight: false,
    template: function (l) {
      return `${l} ${this.label}`
    }
  },

  CONTAINS: {
    name: 'contains',
    label: 'Contains',
    hasRight: true,
    template: function (l, r) {
      return `${l} ${this.label} ${r}`
    }
  },
  NOT_CONTAINS: {
    name: 'not contains',
    label: 'Does Not Contain',
    hasRight: true,
    template: function (l, r) {
      return `${l} ${this.label} ${r}`
    }
  },
  STARTS_WITH: {
    name: 'starts with',
    label: 'Starts With',
    hasRight: true,
    template: function (l, r) {
      return `${l} ${this.label} ${r}`
    }
  },
  ENDS_WITH: {
    name: 'ends with',
    label: 'Ends With',
    hasRight: true,
    template: function (l, r) {
      return `${l} ${this.label} ${r}`
    }
  }
}

export const types = {
  String: {
    comparators: [
      'EQU',
      'NEQ',
      'CONTAINS',
      'NOT_CONTAINS',
      'STARTS_WITH',
      'ENDS_WITH'
    ]
  },
  Number: {
    comparators: ['EQU', 'NEQ', 'LES', 'LEQ', 'GEQ', 'GRT']
  },
  Boolean: {
    comparators: ['EQU']
  }
}

export const formatPredicateExpected = (predicate) => {
  const path = `body${predicate.jpQuery}`
  const comparator = comparators[predicate.comparator].label
  const value = predicate.rValue

  return `${path} ${comparator} ${value}`
}

export const formatPredicateResult = (result) => {
  if (result.queryValue !== undefined) {
    return result.queryValue
  }
  if (result.errors?.length) {
    return result.errors.join(', ')
  }
  return ''
}

export const isPredicateEmpty = (predicate) => {
  if (!predicate.jpQuery && !predicate.rValue) {
    return true
  }
  return false
}
